import * as firebase from 'firebase/app'
import 'firebase/database'

import { randomId, delay, fbMemberName } from './utils'

const LS_KEY = 'store'
const STORE_BASE = {
  fb: {
    profiles: {},
    pages: {},
    groups: {},
    posts: {}
  },
  web: {},
  timestampClipboard: 0,
}
const STORE_ROOTS = Object.keys(STORE_BASE)
const AUTOSAVE_INTERVAL = 10 * 1000

const db = firebase.database()

const firebaseIdSubs = {
  '.': 'dot',
  '#': 'oct',
  '$': 'dlr',
  '/': 'sls',
  '[': 'obr',
  ']': 'cbr'
}
const firebaseIdInvSubs = Object.fromEntries(
  Object.entries(firebaseIdSubs).map(([k, v]) => [v, k])
)
const firebaseIdSubReStr = '[' + Object.keys(firebaseIdSubs)
  .map(char => `\\${char}`)
  .concat()
  .join('') + ']'
const firebaseIdSubRe = new RegExp(firebaseIdSubReStr, 'g')
const firebaseIdInvSubRe = /&(\w{3});/g

export default {
  data() {
    return {
      state: {
        busyDialog: {
          show: false,
          title: ''
        }
      }
    }
  },
  created() {
    this.initStore()
    this.autoSave()
  },
  computed: {
    busyDialogShown() { return this.state.busyDialog.show },
    busyDialogTitle() { return this.state.busyDialog.title }
  },
  methods: {
    showBusyDialog(title) {
      this.state.busyDialog.show = true
      this.state.busyDialog.title = title
    },
    hideBusyDialog() {
      this.state.busyDialog.show = false
    },
    initStore() {
      for (let root of STORE_ROOTS)
        this[root] = {}
      
      var store = JSON.parse(localStorage.getItem(LS_KEY))
      if (store != null)
        for (let root of STORE_ROOTS)
          this.$set(this, root, store[root] || {})
      else
        this.fetchStore()
    },
    saveStore() {
      const store = {}
      for (let root of STORE_ROOTS)
        store[root] = this[root]

      let storeStr = JSON.stringify(store)
      localStorage.setItem(LS_KEY, storeStr)
      return JSON.parse(storeStr)
    },
    async autoSave() {
      await delay(AUTOSAVE_INTERVAL) // lol very crude
      this.saveStore()
      this.autoSave()
    },
    async commitStore() {
      this.showBusyDialog('Saving...')

      try {
        const store = this.toFirebaseFriendly(this.saveStore())
        store.__revision__ = randomId()
        store.__timestamp__ = Date.now()
        await db.ref().set(store)
      } catch (e) {
        alert('An error occurred while saving')
        console.error(e)
      }

      this.hideBusyDialog()
    },
    async fetchStore() {
      this.showBusyDialog('Fetching...')

      try {
        let remote = (await db.ref().once('value')).val()
        remote = this.fromFirebaseFriendly(remote)
        localStorage.setItem(LS_KEY, JSON.stringify(remote))
        location.reload()
      } catch (e) {
        alert('An error occurred while fetching')
        console.error(e)
      } finally {
        this.hideBusyDialog()
      }
    },
    toFirebaseFriendly(obj) {
      if (Array.isArray(obj)) {
        return obj.map(e => this.toFirebaseFriendly(e))
      } else if (typeof obj === 'object' && obj != null) {
        if (Object.keys(obj).length === 0)
          return { '__emptyObj__': true }

        const replacer = (match) => firebaseIdSubs[match]
          ? `&${firebaseIdSubs[match]};` : match

        return Object.fromEntries(
          Object.entries(obj)
            .map(([k, v]) => {
              const k1 = k.replace(firebaseIdSubRe, replacer)
              const v1 = this.toFirebaseFriendly(v)
              return [k1, v1]
            })
        )
      } else {
        return obj
      }
    },
    fromFirebaseFriendly(obj) {
      if (Array.isArray(obj)) {
        return obj.map(e => this.fromFirebaseFriendly(e))
      } else if (typeof obj === 'object' && obj != null) {
        if (Object.keys(obj).length === 1 && obj['__emptyObj__'])
          return {}

        const replacer = (match, p1) => firebaseIdInvSubs[p1] || match
        
        return Object.fromEntries(
          Object.entries(obj)
            .map(([k, v]) => {
              const k1 = k.replace(firebaseIdInvSubRe, replacer)
              const v1 = this.fromFirebaseFriendly(v)
              return [k1, v1]
            })
        )
      } else {
        return obj
      }
    },
    fbMembers(query) {
      const items = []

      const matchesQuery = name => name.split(' ')
        .some(w => w.toLowerCase().includes(query.toLowerCase()))

      const getItems = (members, type) => {
        for (let id in members || {}) {
          if (id.startsWith('RAND_'))
            continue

          const member = members[id]
          const name = fbMemberName(member)

          if (!query || matchesQuery(name)) {
            items.push({
              ref: `@${type}:${id}`,
              picture: member.profilePicture,
              name
            })
          }
        }
      }
      
      getItems(this.fb.profiles, 'u')
      getItems(this.fb.pages, 'p')
      getItems(this.fb.groups, 'g')
      return items.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase())
    },
    getWebPage(url) {
      if (url.startsWith('https://'))
        url = url.substr('https://'.length)
      let page = this.web

      for (let path of [...url.split('/'), '.']) {
        page = page[path]
        if (page == null)
          return
      }

      return page
    }
  }
}
